import {
  Companion_getInstance10dt578q09swj as Companion_getInstance,
  Instant2s2zyzgfc4947 as Instant,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KotlinInstantAdapterClass;
function KotlinInstantAdapter() {
  if (KotlinInstantAdapterClass === VOID) {
    class $ {
      t3x(reader, customScalarAdapters) {
        return Companion_getInstance().wr(ensureNotNull(reader.t3y()));
      }
      x4e(writer, customScalarAdapters, value) {
        writer.v3y(value.toString());
      }
      u3x(writer, customScalarAdapters, value) {
        return this.x4e(writer, customScalarAdapters, value instanceof Instant() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'KotlinInstantAdapter', VOID, VOID, [Adapter()]);
    KotlinInstantAdapterClass = $;
  }
  return KotlinInstantAdapterClass;
}
var KotlinInstantAdapter_instance;
function KotlinInstantAdapter_getInstance() {
  return KotlinInstantAdapter_instance;
}
//region block: init
KotlinInstantAdapter_instance = new (KotlinInstantAdapter())();
//endregion
//region block: exports
export {
  KotlinInstantAdapter_instance as KotlinInstantAdapter_instance19tdzzheivj7r,
};
//endregion

//# sourceMappingURL=KotlinInstantAdapter.mjs.map
